import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonMenu } from '../table/table.component';
import { TableService } from '../table/table-service';
import { AuxiliarOption } from '../../../types/signaturit/shared-types';

@Component({
  selector: 'signaturit-kebab-menu',
  templateUrl: './kebab-menu.component.html',
  styleUrls: ['./kebab-menu.component.scss']
})
export class KebabMenuComponent {

  @Input() tableId: string;

  @Input() kebabMenuOptions: ButtonMenu[];

  @Input() kebabMenuOptionsFilter: ((k: ButtonMenu[], el: unknown) => ButtonMenu[]);

  @Input() element: unknown;

  @Input() disabled: boolean = false;

  @Input() blockReceivers: boolean = false;

  @Output('clickKebabOption') clickKebabOption: EventEmitter<AuxiliarOption> = new EventEmitter<AuxiliarOption>();

  filteredMenuOptions: ButtonMenu[];

  constructor(private _table: TableService) { }

  menuOpened(): void {
    switch (this.tableId) {
      case 'contacts_table':
        this.kebabMenuOptions = this._table.validateKebabOptionsContact(this.element, this.kebabMenuOptions);
        break;
      case 'recipients':
        this.kebabMenuOptions = this._table.validateKebabOptionsRecipients(this.element, this.kebabMenuOptions, this.blockReceivers);
        break;
      case 'custom_recipients':
        this.kebabMenuOptions = this._table.validateKebabOptionsCustomRecipients(this.element, this.kebabMenuOptions, this.blockReceivers);
        break;
      case 'areas_circuits_table':
        this.kebabMenuOptions = this._table.validateKebabOptionsArea(this.element, this.kebabMenuOptions);
        break;
      case 'sent_circuits_table':
        this.kebabMenuOptions = this._table.validateKebabOptionsSentCircuits(this.element, this.kebabMenuOptions);
        break;
    }

    if (this.kebabMenuOptionsFilter) {
      this.filteredMenuOptions = this.kebabMenuOptionsFilter(this.kebabMenuOptions, this.element);
    }
  }

  onclickKebab(actionKey: string, rowData: unknown): void {
    this.clickKebabOption.emit({ action: actionKey, row: rowData });
  }

}
